<template>
  <div class="prod_recommend_content">
    <div class="prod_recommend_head">
      <h3>推荐产品</h3>
      <span @click.prevent="reload">换一批</span>
    </div>
    <ul>
      <li @click="toDetail(item)" v-for="(item, index) in list" :key="index">
        <img :src="item.cover" alt="" />
        <div class="prod_info">
          <p class="prod_title">{{ item.title }}</p>
          <p class="prod_desc">
            <span v-if="item.companyname != null">{{ item.companyname }}</span>
            <span v-else>天途路业集团有限公司</span>
            <span class="prod_price">￥{{ item.price }}元</span>
          </p>

        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
    toDetail(item) {
      routerGoNewpage("/supply_detail",{id:item.id})
    },
  }
};
</script>

<style scoped lang="less">
.prod_recommend_content {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  padding: 16px;
  .prod_recommend_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      &::before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        background: url("../assets/images/break.png") no-repeat center/100%;
        vertical-align: top;
        margin-right: 3px;
      }
    }
  }
  ul {
    li {
      padding: 10px 0;
      cursor: pointer;
      img {
        width: 100%;
        height: 168px;
      }
      .prod_info {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
        .prod_title{
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .prod_desc {
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            &:nth-of-type(1) {
              font-size: 15px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #343434;
              margin-top: 5px;
              display: inline-block;
              width: 70%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
            &:nth-of-type(2) {
              // font-size: 14px;
              // font-family: Microsoft YaHei;
              // font-weight: 400;
              // color: #9a9a9a;
              // margin-top: 5px;

              font-size: 16px;
              font-family: Arial;
              font-weight: 400;
              color: #ff7402;
            }
          }
        }
        .prod_price {
          font-size: 18px;
          font-family: Arial;
          font-weight: 400;
          color: #ff7402;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/prodRecommend.vue